import snackmagicLogo from "@stadium/ui/src/assets/images/svg/brands/snackmagic.svg";
import swagmagicLogo from "@stadium/ui/src/assets/images/svg/brands/swagmagic.svg";
import stadiumLogo from "@stadium/ui/src/assets/images/svg/brands/stadium.svg";
import stadiumLogoWithoutDesc from "@stadium/ui/src/assets/images/svg/brands/stadium-logo.svg";
import stadiumMobileLogo from "@stadium/ui/src/assets/images/svg/brands/stadium-mobile.svg";

import snackmagicLogoWhite from "@stadium/ui/src/assets/images/svg/snackmagic.svg";
import swagmagicLogoWhite from "@stadium/ui/src/assets/images/svg/swagmagic.svg";

export const STADIUM = {
  key: "stadium",
  logo: stadiumLogo,
  logo2: stadiumLogoWithoutDesc,
  mobileLogo: stadiumMobileLogo,
  imgAlt: "Stadium",
  url: "https://www.bystadium.com",
  shortDesc: "1 Account, Many Brands",
  desktopImgWidth: 113,
  mbImgWidth: 130,
  tabImgWidth: 85,
  themeClr: "#2C2D2E",
};

export const SNACKMAGIC = {
  key: "snackmagic",
  logo: snackmagicLogo,
  logo2: snackmagicLogoWhite,
  imgAlt: "Snackmagic",
  url: process.env.NEXT_PUBLIC_SNACKMAGIC_TEST_URL || "https://www.snackmagic.com/",
  shortDesc: "All things snacks and sips",
  desktopImgWidth: 128,
  mbImgWidth: 70,
  tabImgWidth: 85,
  themeClr: "#2C43DD",
};

export const SWAGMAGIC = {
  key: "swagmagic",
  logo: swagmagicLogo,
  logo2: swagmagicLogoWhite,
  imgAlt: "SwagMagic",
  url: process.env.NEXT_PUBLIC_SWAGMAGIC_TEST_URL || "https://www.swagmagic.com/",
  shortDesc: "Make, give and sell branded merch",
  desktopImgWidth: 132,
  mbImgWidth: 90,
  tabImgWidth: 85,
  themeClr: "#30623B",
};
